import _ from 'lodash'

export type ApiTranslations = { key: string; value: string }[]

export function parseTranslations(translations: ApiTranslations) {
  return _.reduce(
    translations,
    (acc, translation) => {
      if (_.includes(translation.key, '.')) {
        _.set(acc, translation.key, translation.value)
      }
      return acc
    },
    {} as any
  )
}
